module.exports = __webpack_public_path__ + "static/img/footer-logo.f2be8eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer-logo.png
// module id = ScAa
// module chunks = 1